import { css } from 'styled-components';
import { FontLineHeightTight } from 'autogen/design-tokens/global/tokens';

const HeadlineStyling = css`
    font-family: ${({ theme }) => theme.TypographyFamilySecondary};
    font-weight: ${({ theme }) => theme.TypographyHeadlineWeight};
    line-height: ${FontLineHeightTight};
    margin-top: 0;
    margin-bottom: 0;
`;

export default HeadlineStyling;
